import Model from './Model'

export default class Callback extends Model {
    getFormAttributes() {
        const attributes = this.getAttributes()
        attributes.package_id = {label: this.package_name, value: this.package_id}
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes.package_id = attributes.package_id?.value;
        if (!attributes.package_id && attributes.package) {
            attributes.package_id = attributes.package.value
        }
        return attributes
    }

    static async all(packageId = null) {
        const params = {package_id: packageId}
        const {data} = await Http.get(route('api.v1.callbacks.index'), {params})
        return this.make(data)
    }

    static async allOpened() {
        const params = {open: true}
        const {data} = await Http.get(route('api.v1.callbacks.index'), {params})
        return this.make(data)
    }

    static async allWithActivity(filters = {}) {
        const params = {has_activity: true, from: filters?.from, to: filters?.to}
        const {data} = await Http.get(route('api.v1.callbacks.index'), {params})
        return this.make(data)
    }

    static async create(attributes) {
        const url = route('api.v1.callbacks.store')
        const {data} = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v1.callbacks.update', this.id)
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const {data} = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v1.callbacks.destroy', this.id))
    }

    async reopen() {
        const {data} = await Http.put(route('api.v1.callbacks.reopen', this.id))
        return this.fill(data)
    }

    async close() {
        const {data} = await Http.put(route('api.v1.callbacks.close', this.id))
        return this.fill(data)
    }

    async copyToNcr() {
        await Http.put(route('api.v1.callbacks.copy-to-ncr', this.id))
    }

    async copyToDefect() {
        await Http.put(route('api.v1.callbacks.copy-to-defect', this.id))
    }
}
